// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header h2 {
  margin-bottom: 2.4rem;
}
.header p {
  max-width: 70rem;
}
.header .disclaimer {
  margin-top: 2.4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/LoginScene/LoginForm/MfaForm/index.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ","sourcesContent":[".header {\n  h2 {\n    margin-bottom: 2.4rem;\n  }\n\n  p {\n    max-width: 70rem;\n  }\n\n  .disclaimer {\n    margin-top: 2.4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
